<style lang="less">

</style>
<template>
	<v-btn v-bind="bindings">
		<v-icon v-if="element.buttonIcon" v-text="element.buttonIcon" :size="element.attrs.size"></v-icon>
		<span v-html="element.text"></span>
	</v-btn>
</template>

<script>
	export default {
		name: "DisplayButton",
		props:{
			element: {type: Object},
		}, 
		data: () =>{
			return {			

			}
		},
		computed: {
			bindings(){
				var bindings = {
					id: this.element.id
				}
				bindings[this.element.attrs.size] = true;
				bindings.link = this.element.link.length > 0;
				bindings.color = this.element.attrs.colors.background;
				if( bindings.link ){
					bindings.href = this.element.link;
				}
				if( this.element.attrs.dark ){
					bindings.dark = true
				}
				else{
					bindings.light = true
				}
				if( this.element.attrs.text ){
					bindings.text = true
				}
				else{
					bindings.tile = true
				}
				if( this.element.buttonIcon ){
					bindings.icon = true;
				}
				return bindings;
			},
			classes(){
				var object = {}
				object[this.element.attrs.padding] = this.element.attrs.padding ? true : false;
				object[this.element.attrs.margin] = this.element.attrs.margin ? true : false;
				return object;
			},
		}
	}
</script>